export const ScheduleRange = {
    completeview : 'completeview',
    completedata : 'completedata',
    currentview  : 'currentview',
    daterange    : 'daterange'
};
